module.exports = __webpack_public_path__ + "static/media/sniper_rifle_1.aded77df.mp3";